module.exports = __webpack_public_path__ + "static/media/ni.585b69e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ni.svg
// module id = 210
// module chunks = 0